<template>
  <div class="home-page">
    
    <van-nav-bar>
      <template #left>
        <van-image src="img/home/logo3.png" width="52"></van-image>
      </template>
    </van-nav-bar>

    <div id="content">
      <div class="banner">
        <swiper class="banner_swiper" :options="bannerSwiperOption">
          <swiper-slide v-for="(v, key) in banners" :key="key">
            <van-image class="banner_img" round :src="v.url">
              <template v-slot:loading>
                <van-loading type="circular" />
              </template>
            </van-image>
          </swiper-slide>
        </swiper>
      </div>

      <div class="content">
        <div class="txt">
          <span> HOT </span>
          <span class="icon">{{ $t('index.title1') }}</span>
        </div>
        <div class="swiper_wrap">
          <div class="swiper" :style="{ width: `calc(${9.35 * xuanfeiList.length}rem)` }">
            <div v-for="item in xuanfeiList" :key="item.id" class="swipe" @click="goDetail(item)">
              <van-image :src="item.img_url[0]"></van-image>
              <div class="tip">
                <span>{{ $t('index.tip1') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="txt">{{ $t('index.title2') }}</div>
        <div class="ganeGroup">
          <div class="gameItem" v-for="item in gameList" :key="item.id" @click="goGame(item)">
            <div class="image">
              <van-image   :src="item.ico"></van-image>
            </div>
            <div class="label">{{ item.name }}</div>
          </div>
        </div>
        <div class="txt">{{ $t('index.title3') }}</div>
        <div class="xuanfeiList">
          <div class="row" v-for="item in xuanfeiList" :key="item.id" @click="goDetail(item)">
            <div class="left">
              <div class="photo">
                <van-image :src="item.img_url[0]"></van-image>
                <div class="tip">
                  <span>{{ $t('index.tip2') }}</span>
                </div>
              </div>
            </div>

            <div class="right">
              <div class="name">{{ item.xuanfei_name }}</div>
              <div class="renzheng">
                <div>{{ $t('index.icon1') }}</div>
                <div>{{ $t('index.icon2') }}</div>
              </div>
              <div class="biaoqian">
                <div v-for="(biaoqian, index) in item.type.slice(0, 3)" :key="index">{{ biaoqian.name }}</div>
              </div>
              <div class="xingji">
                <div>
                  <span>{{ $t('index.label1') }}：</span>
                  <van-icon name="star" color="#bfa06a" size="0.85rem" />
                  <van-icon name="star" color="#bfa06a" size="0.85rem" />
                  <van-icon name="star" color="#bfa06a" size="0.85rem" />
                  <van-icon name="star" color="#bfa06a" size="0.85rem" />
                  <van-icon name="star" color="#bfa06a" size="0.85rem" />
                </div>
              </div>
              <div class="info">
                <div>{{ item.info }}</div>
              </div>
            </div>
            <div class="button2">{{ $t('index.button') }}</div>
          </div>
        </div>
        <div class="plCard">
          <div class="title">Live Feed</div>
          <swiper class="pl_swiper"  :options="plOption">
            <swiper-slide style="text-align: center; color: #8a8378;height: 1.5rem;line-height: 1.5rem;" v-for="(v, key) in plList" :key="key">{{ v }}</swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banners: [],
      tuis: [
        {
          id: 1,
          num: '001',
          name: '',
          pic: require("@/assets/imgs/index_pic/1.jpg"),
          avatar: require("@/assets/imgs/index_avatar/11.jpg"),
          sui: '22yo / 165cm / 46kg'
        },
        {
          id: 2,
          num: '002',
          name: '',
          pic: require("@/assets/imgs/index_pic/2.jpg"),
          avatar: require("@/assets/imgs/index_avatar/12.jpg"),
          sui: '26yo / 170cm / 53kg'
        },
        {
          id: 3,
          num: '003',
          name: '',
          pic: require("@/assets/imgs/index_pic/3.jpg"),
          avatar: require("@/assets/imgs/index_avatar/13.jpg"),
          sui: '21yo / 169cm / 51kg'
        },
        {
          id: 4,
          num: '004',
          name: '',
          pic: require("@/assets/imgs/index_pic/4.jpg"),
          avatar: require("@/assets/imgs/index_avatar/14.jpg"),
          sui: '23yo / 165cm / 49kg'
        },
        {
          id: 5,
          num: '005',
          name: '',
          pic: require("@/assets/imgs/index_pic/5.jpg"),
          avatar: require("@/assets/imgs/index_avatar/15.jpg"),
          sui: '25yo / 167cm / 50kg'
        },
        {
          id: 6,
          num: '006',
          name: '',
          pic: require("@/assets/imgs/index_pic/6.jpg"),
          avatar: require("@/assets/imgs/index_avatar/16.jpg"),
          sui: '22yo / 162cm / 47kg'
        },
        {
          id: 7,
          num: '007',
          name: '',
          pic: require("@/assets/imgs/index_pic/7.jpg"),
          avatar: require("@/assets/imgs/index_avatar/17.jpg"),
          sui: '34yo / 170cm / 54kg'
        },
        {
          id: 8,
          num: '008',
          name: '',
          pic: require("@/assets/imgs/index_pic/8.jpg"),
          avatar: require("@/assets/imgs/index_avatar/18.jpg"),
          sui: '30yo / 166cm / 49kg'
        },
        {
          id: 9,
          num: '009',
          name: '',
          pic: require("@/assets/imgs/index_pic/9.jpg"),
          avatar: require("@/assets/imgs/index_avatar/19.jpg"),
          sui: '24yo / 172cm / 52kg'
        },
        {
          id: 10,
          num: '010',
          name: '',
          pic: require("@/assets/imgs/index_pic/10.jpg"),
          avatar: require("@/assets/imgs/index_avatar/20.jpg"),
          sui: '22yo / 168cm / 49kg'
        }
      ],
      bannerSwiperOption: {
        autoplay: true,
      },
      xuanfeiList: [],
      gameList: [],
      plList: [
        'jx***ib has signed up',
        '95***8f has signed up',
        '71***8c completed a match',
        'xf***45 completed a match',
        'rw***32 completed a match',
        '5n***8m completed a match',
        'bv***f3 has signed up',
        '44***uc has signed up',
        'xo***n0 completed a match',
        'xm***19 has signed up',
        'ha***2g completed a match',
        'or***ze completed a match',
        'df***ux completed a match',
        'zb***is completed a match',
        'ud***c3 has signed up',
        'n8***42 has signed up',
        'm3***r8 has signed up',
        'p1***5a has signed up',
        'ab***9e has signed up',
        '0v***dz has signed up',
        'jx***ib has signed up',
        '95***8f has signed up',
        '71***8c completed a match',
        'xf***45 completed a match',
        'rw***32 completed a match',
        '5n***8m completed a match',
        'bv***f3 has signed up',
        '44***uc has signed up',
        'xo***n0 completed a match',
        'xm***19 has signed up'
      ],
      plOption: {
        autoplay: true,
        direction: 'vertical',
        slidesPerView: 5,
        speed: 800,
      }
    }
  },
  computed: {
    swipeWidth() {
      return window.innerWidth * 0.45
    }
  },
  methods: {
    getBasicConfig() {
      this.$http({
        method: 'get',
        url: 'sys_config'
      }).then(res => {
        this.banners = res.data?.banners || [];
      })

    },

    getXuanfeiList() {
      this.$http({
        method: 'get',
        url: 'xuanfei_list'
      }).then(res => {
        if (res.code === 200) {
          this.xuanfeiList = res.data.data.map(item => {
            item.info = `Height: ${item.height}cm  Size: ${item.bust}  Available Area: ${item.diqu}`
            return item
          })
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },

    goDetail(e) {
      localStorage.setItem('xuanfeiDetail', JSON.stringify(e))
      this.$router.push(`XuanfeiDetail`);
    },

    goGame(e) {
      if(!localStorage.getItem('token')){
        this.$router.push({path:'/Login'})
      }else {
        this.$router.push({path:'/WindowLottery?key='+e.key+"&id="+e.id})
      }
    },

    
    getGameItem(){
      this.$http({
        method: 'get',
        url: 'lottery_list'
      }).then(res=>{
        this.gameList = res.data;
      })
    },
  },
  created() {
    this.getBasicConfig();
    this.getGameItem()
    this.getXuanfeiList()
  }
}
</script>


<style lang="less" scoped>
@import '~@/assets/css/theme.less';

.home-page {
  min-height: 100%;
  background: @bg-page;
}

.home-page .van-nav-bar {
  background: @bg-page;
  box-shadow: none;
  ::v-deep .van-image__img {
    filter: brightness(0) saturate(100%);
    opacity: 0.88;
  }
  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 1px;
    background: @line;
  }
}

#content{
  padding-bottom: 3.2rem;
}

.banner {
  padding: 0;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 0.1rem;
    background: @gold;
    z-index: 2;
  }
}

.banner_swiper {
  height: 100%;
  width: 100%;
  border-radius: 0;
  overflow: hidden;

  .swiper-slide {
    // border-radius: 1.25rem;
    display: flex;
    justify-content: center;
    align-items: center;
    // width: 19.375rem;
    width: 100%;
    height: 12.2rem;
    text-align: center;
    font-weight: bold;
    font-size: 0.625rem;
    background-color: #ffffff;
    background-position: center;
    background-size: cover;
    color: #ffffff;
  }

  ::v-deep .swiper-container-3d .swiper-slide-shadow-left {
    background-image: linear-gradient(to left, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
  }

  ::v-deep .swiper-container-3d .swiper-slide-shadow-right {
    background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
  }

  .banner_img {
    border-radius: 0;
    width: 100%;
    height: 100%;
  }
}

.content {
  width: 100%;
  padding: 0 1.15rem 1.2rem;

  .txt {
    font-size: 1.08rem;
    font-weight: 600;
    letter-spacing: 0.02rem;
    color: @text-title;
    margin-top: 1.55rem;
    margin-bottom: 0.9rem;
    line-height: 1.45;
    &::after {
      content: '';
      display: block;
      height: 1px;
      margin-top: 0.5rem;
      background: @line;
    }
    > span:first-child {
      color: @wine;
      font-size: 0.72rem;
      letter-spacing: 0.16rem;
      font-weight: 600;
      margin-right: 0.55rem;
    }
    .icon{
      display: inline-block;
      background: transparent;
      color: @text-title;
      font-weight: 600;
      padding: 0;
      font-size: 1.08rem;
      letter-spacing: 0.04rem;
    }
  }


  .swiper_wrap {
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
      display: none;
    }

    .swiper {
      display: flex;
      scroll-snap-type: x mandatory;

      .swipe {
        flex-shrink: 0;
        scroll-snap-align: start;
        width: 8.6rem;
        height: auto;
        overflow: visible;
        margin-right: 0.75rem;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        position: relative;
        border-radius: 0;

        ::v-deep .van-image,
        ::v-deep .van-image__img {
          width: 100%;
          height: 11.2rem;
          border-radius: 0.08rem;
          object-fit: cover;
          object-position: center 18%;
        }

        .tip {
          position: static;
          z-index: 1;
          width: 100%;
          height: auto;
          transform: none;
          background: none;
          display: block;
          padding: 0.32rem 0 0;

          span {
            position: static;
            display: block;
            width: 100%;
            font-size: .7rem;
            font-weight: 500;
            line-height: 1.35;
            color: @text-sub;
            white-space: normal;
          }
        }
      }
    }
  }

  .xuanfeiList {
      .row {
      display: block;
      width: 100%;
      background: transparent;
      border: none;
      border-radius: 0;
      box-shadow: none;
      padding: 0 0 1.2rem;
      margin-bottom: 1.2rem;
      border-bottom: 1px solid @line;

      .left {
        width: 100%;
        color: @text-title;

        .photo {
          position: relative;
          height: 12.6rem;
          overflow: hidden;
          border-radius: 0.08rem;
        }

        ::v-deep .van-image,
        ::v-deep .van-image__img {
          width: 100%;
          height: 12.6rem;
          border-radius: 0;
          object-fit: cover;
          object-position: center 18%;
          display: block;
        }

        .tip {
          position: absolute;
          left: 0.4rem;
          bottom: 0.4rem;
          top: auto;
          right: auto;
          width: auto;
          height: auto;
          transform: none;
          background: rgba(36, 31, 27, 0.78);
          color: #f6edd8;
          padding: 0.12rem 0.4rem;

          span {
            position: static;
            font-weight: 500;
            font-size: .68rem;
            letter-spacing: 0.03rem;
          }
        }
      }

      .right {
        width: 100%;
        max-width: 100%;
        padding: 0.75rem 0 0;

        .name {
          font-size: 1.08rem;
          font-weight: 600;
          color: @text-title;
          letter-spacing: 0.02rem;
          margin-bottom: 0.35rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .renzheng {
          display: flex;
          flex-wrap: wrap;
          gap: 0.35rem 0.4rem;

          >div {
            background: #f7f2e8;
            border: 1px solid @line-gold;
            color: @gold-deep;
            font-weight: 600;
            margin-left: 0;
            padding: .16rem .4rem;
            font-size: .73333rem;
            border-radius: 0.12rem;
            max-width: 100%;
            white-space: normal;
            display: flex;
            align-items: center;

            &::before {
              content: '';
              width: .8125rem;
              height: .8125rem;
              background: url('/public/img/home/icon.png');
              background-size: 100% 100%;
            }
          }
        }

        .biaoqian {
          display: flex;
          flex-wrap: wrap;
          padding: 0.3rem 0;

          div {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: .2rem .4rem;
            margin: .16667rem .16667rem;
            border-radius: 0.25rem;
            font-size: .76667rem;

            &:nth-child(1n) {
              background-color: #f7f2e8;
              color: @gold-deep;
              border: 1px solid @line-gold;
            }

            &:nth-child(2n) {
              background-color: #f6efef;
              color: @wine;
              border: 1px solid rgba(140, 47, 57, 0.28);
            }

            &:nth-child(3n) {
              background-color: #f2efe9;
              color: @text-body;
              border: 1px solid @line;
            }
          }
        }

        .xingji {
          color: @text-body;
          font-size: .9rem;
          padding-bottom: .3rem;
        }

        .info {
          overflow: hidden;

          >div {

            font-size: .9rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: @text-sub;
          }
        }

      }

      .button2 {
        width: 100%;
        text-align: center;
        background: @wine;
        font-weight: 500;
        letter-spacing: 0.06rem;
        color: #fff;
        border-radius: 0.08rem;
        padding: 0.55rem 0;
        margin-top: 0.85rem;
      }
    }
  }

  .ganeGroup{
    display: block;
    background: transparent;
    border: none;
    border-top: 1px solid @line;
    border-radius: 0;
    box-shadow: none;
    padding: 0;
    .gameItem{
      display: flex;
      align-items: center;
      text-align: left;
      padding: 0.75rem 0;
      border-bottom: 1px solid @line;
    }
    .image{
      width: 3.6rem;
      height: 3.6rem;
      margin: 0 0.85rem 0 0;
      flex-shrink: 0;
    }
    .label{
      flex: 1;
      font-size: 1rem;
      padding-top: 0;
      font-weight: 500;
      color: @text-title;
    }
    .van-image{
      width: 100%;
      height: 100%;
    }
  }

  .plCard{
    width: 100%;
    margin: 0.4rem auto 1.25rem;
    height: auto;
    padding: 0.2rem 0 0.6rem;
    background: transparent;
    border-radius: 0;
    border: none;
    box-shadow: none;
    .title{
      color: @gold-deep;
      font-weight: 600;
      letter-spacing: 0.16rem;
      font-size: 0.82rem;
      text-align: left;
      margin-bottom: 0.45rem;
    }
    .pl_swiper{
      height: 7.5rem;
    }
  }
}
</style>